<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="row col-12">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Listagem de Papéis
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-ml-sm q-mt-md text-brand-5 q-gutter-sm text-weight-bold container-inputs"
    >
      <div class="col-md-3 col-xs-8 col-sm-8">
        <div class="q-ml-sm titulo-input">Nome</div>
        <q-input v-model="dados.nome" class="input" dense outlined />
      </div>
      <div>
        <p></p>
        <q-btn
          label="Criar"
          class="q-mt-sm btn"
          icon="add"
          color="positive"
          no-caps
          @click="adicionarPapel()"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div
        class="row texto-titulo-tabela col-12 q-ml-md q-my-lg text-brand-5 text-subtitle1 text-weight-bold"
      >
        Lista de Papéis
      </div>
      <q-table
        :columns="columns"
        :rows="listaDePapeis"
        :loading="loading"
        color="primary"
        dense
        table-header-class="bg-accent text-weight-bold"
        flat
        class="tabela-tamanho-fixo"
        hide-bottom
        hide-pagination
        :grid="$q.screen.lt.sm"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-8">
                  <span class="q-ml-sm q-mt-sm"
                    ><strong>Nome: </strong>{{ props.row.name }}</span
                  >
                </div>
                <div class="col-2">
                  <div>
                    <q-btn
                      @click="detalharPapel(props.row.id)"
                      flat
                      color="primary"
                      icon="manage_accounts"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-nome="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.name }}
          </q-td>
        </template>
        <template v-slot:body-cell-permissoes="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <router-link
              :to="{
                name: 'perfis-permissoes',
                params: { roleId: props.row.id },
              }"
            >
              <q-btn flat color="primary" icon="manage_accounts" />
            </router-link>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { useQuasar } from "quasar";
import { onMounted, ref, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
const columns = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "permissoes",
    label: "Permissões",
    align: "left",
  },
];
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const quasar = useQuasar();

    const listaDePapeis = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });
    let disable = ref(false);
    let loading = ref(false);
    const dados = ref({
      descricao: "",
      nome: "",
    });

    const listarRoles = async (page = 0, rowsPerPage = 6) => {
      disable.value = true;
      loading.value = true;
      const response = await store.dispatch("perfis/listarRoles", {
        per_page: rowsPerPage,
        page: page,
      });
      listaDePapeis.value = response.data.results.data;
      pagination.value.rowsPerPage = response.data.results.per_page;
      pagination.value.page = response.data.results.current_page;
      pagination.value.rowsNumber = response.data.results.total;
      disable.value = false;
      loading.value = false;
    };
    const detalharPapel = async (id) => {
      router.push({ name: "perfis-permissoes", params: { roleId: id } });
    };
    const paginarTabela = async () => {
      listarRoles(pagination.value.page, pagination.value.rowsPerPage);
    };

    const adicionarPapel = async () => {
      try {
        await store.dispatch("perfis/criarPapel", {
          description: dados.value.nome,
          display_name: dados.value.nome,
        });
        listarRoles();
        reset();
        quasar.notify({
          message: "Papel adicionado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao adicionar papel",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const reset = async () => {
      dados.value = {
        descricao: "",
        nome: "",
      };
    };

    watch(
      () => pagination.value.page,
      () => {
        listarRoles(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    onMounted(listarRoles);
    return {
      listarRoles,
      columns,
      listaDePapeis,
      detalharPapel,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      paginarTabela,
      loading,
      adicionarPapel,
      dados,
      reset,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .titulo-input {
    font-size: 12px;
    margin: 0px;
  }
  .input {
    font-size: 12px;
  }
  .btn {
    margin: 6px 0px 0px 0px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 14px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
}
</style>
